export const scrollFix = function (hash: string) {
    window.location.hash = hash;
}